var render, staticRenderFns
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109a6b29')) {
      api.createRecord('109a6b29', component.options)
    } else {
      api.reload('109a6b29', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2PMEZMel14lp5/JS/carousel.vue"
export default component.exports